import { useEffect, useState } from "react";

const COMPONENT_UNMOUNTED_ABORT_REASON = "Component unmounted";
class ComponentUnmountedAbortReason {
   message = COMPONENT_UNMOUNTED_ABORT_REASON
}

export function isComponentUnmountedAbortReason(obj?): obj is ComponentUnmountedAbortReason {
   return obj instanceof ComponentUnmountedAbortReason;
}

function useUnmountedSignal() {
   const [abortController] = useState(() => new AbortController());
   useEffect(() => () => abortController.abort(new ComponentUnmountedAbortReason()), []);

   return abortController.signal;
}

export default useUnmountedSignal;